// extracted by mini-css-extract-plugin
module.exports = {"welcome__headline":"_1HJCH","welcome__subline":"fZ-AU","welcome__description":"_2jniK"};